import styled from "styled-components"

import { colors, spacing, size, typography, borderRadius, elevation } from "@izettle/otto"

export const DropdownBase = styled.div`
  background: ${colors.background.default};
  border-radius: ${borderRadius.medium};
  box-shadow: ${elevation.level3};
  padding: ${spacing.xxSmall} 0;
  position: absolute;
  margin-top: ${spacing.xxSmall};
  top: ${size.medium};
  min-width: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`

export const DropdownItemContainer = styled.div`
  align-items: center;
  display: flex;
  outline: 0;
  padding: 0 ${spacing.xSmall};
  user-select: none;
  width: 100%;
`

export const DropdownItem = styled.button.attrs({ type: "button" })`
  min-height: ${size.medium};
  text-align: left;

  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  width: 100%;

  ${typography.regular};

  :active,
  :focus,
  :hover {
    background-color: ${colors.background.groupedSecondary};
  }

  :disabled {
    background: none;
    cursor: default;
    color: ${colors.text.disabled};
  }
`
